import * as manualControlActionType from '@/constants/manualControlActionType';

export function setEnableManualControl(value) {
  return {
    type: manualControlActionType.ENABLE_MANUAL_CONTROL,
    value,
  };
}

export function setStartManualControl(value) {
  return {
    type: manualControlActionType.START_MANUAL_CONTROL,
    value,
  };
}

export function setStopManualControl(value) {
  return {
    type: manualControlActionType.STOP_MANUAL_CONTROL,
    value,
  };
}

export function setStatusManualControl(value) {
  return {
    type: manualControlActionType.STATUS_MANUAL_CONTROL,
    value,
  };
}
export function updateManualControlState(value) {
  return {
    type: manualControlActionType.MANUAL_CONTROL_STATE,
    value,
  };
}
export function updateSelectedDefaultTime(value) {
  return {
    type: manualControlActionType.SELECTED_DEFAULT_TIME,
    value,
  };
}
export function updateVolumeInMl(value) {
  return {
    type: manualControlActionType.VOLUME_IN_ML,
    value,
  };
}
export function updateIsHoldToRunActive(value) {
  return {
    type: manualControlActionType.IS_HOLD_TO_RUN_ACTIVE,
    value,
  };
}
export function updateManualControlStartVolume(value) {
  return {
    type: manualControlActionType.MANUAL_CONTROL_START_VOLUME,
    value,
  };
}

export function setRequestPendingManualControl(value) {
  return {
    type: manualControlActionType.REQUEST_PENDING_MANUAL_CONTROL,
    value,
  };
}

export function totalRuntimeManualControl(value) {
  return {
    type: manualControlActionType.TOTAL_RUNTIME_MANUAL_CONTROL,
    value,
  };
}

export function setRecoveryManualControl(value) {
  return {
    type: manualControlActionType.RECOVERY_OF_LIQUID_MANUAL_CONTROL,
    value,
  };
}

export function setCancelManualControl(value) {
  return {
    type: manualControlActionType.CANCEL_MANUAL_CONTROL,
    value,
  };
}

export function IsShowManualControlAvailablePopUp(value) {
  return {
    type: manualControlActionType.IS_SHOW_MANUAL_CONTROL_AVAILABLE_POPUP,
    value,
  };
}

export function IsShowManualControlPopUp(value) {
  return {
    type: manualControlActionType.IS_SHOW_MANUAL_CONTROL_POPUP,
    value,
  };
}
